import { createContext } from "react";

/**
 * The tone-number readings a Learn card treats as introduced: on a new-character lesson, those at
 * or below the lesson's curriculum grade; on a review, those the learner has a pronunciation card
 * for. The Learn binder tab colours these pinyin and mutes the rest. `null` outside a Learn card,
 * where no reading is muted.
 */
export const MorphemeMnemonicsIntroducedReadingsContext = createContext<ReadonlySet<string> | null>(
  null,
);
